<template>
  <div class="match-card match-card__daily-limit text-center">
    <div class="match-card__desc">
      <div class="title">
        {{ trans.get('pages:match_game.daily_limit.header') }}<span>.</span>
      </div>
      <div class="desc">
        {{ trans.get('pages:match_game.daily_limit.subheader') }}
      </div>
    </div>
    <div class="match-card__image">
      <img src="../../../images/match-game/daily-limit.png" alt="">
    </div>
    <div class="match-card__desc desc">
      {{ trans.get('pages:match_game.daily_limit.continue_tip') }}
    </div>
    <router-link :to="{name: 'members'}" class="button button--primary">
      {{ trans.get('pages:match_game.daily_limit.members') }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'DailyLimitReachedCard',
  props: {
    current: Object,
  },
  data() {
    return {};
  },
  computed: {
    avatars: function () {
      return this.$store.getters['homeProfiles/getRandomAvatars'];
    }
  },
  methods: {},
  mounted() {

  }
};
</script>


